import { Component, Input, OnDestroy } from '@angular/core';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { BinCollectionPieComponent } from './bin-collection-pie/bin-collection-pie.component';
import { BinCollectionHistoryComponent } from './bin-collection-history/bin-collection-history.component';
import { BinAnalyticsComponent } from './bin-analytics/bin-analytics.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-bin-collection',
  standalone: true,
  imports: [CommonModule,TranslateModule,RTLDivDirectiveDirective,BinCollectionPieComponent,BinCollectionHistoryComponent,BinAnalyticsComponent],
  templateUrl: './bin-collection.component.html',
  styleUrl: './bin-collection.component.scss'
})
export class BinCollectionComponent implements OnDestroy {
  @Input() binInfo;
	isMobile: boolean;
	translationsObj;
	currentLang;
  private readonly destroy$ = new Subject<void>();

	constructor(private translator: TranslatorService,private responsiveService: ResponsiveService) {
    this.translator.currentLangEmitter$
    .pipe(takeUntil(this.destroy$))
    .subscribe(async value=>{						
      this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
      this.currentLang = value;
    })
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
  }

  ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

  onResize() {
    this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }
}
